<template>
  <v-autocomplete :class="propclass" hide-no-data hide-details clearable flat solo-inverted prepend-inner-icon="mdi-magnify" label="Search" :items="searchResults" item-value="name" v-model="resolveValue" :loading="searchLoading" :search-input.sync="searchKey" id="searchTop">
    <template slot="item" slot-scope="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-item-content>{{data.item}}</v-list-item-content>
      </template>
      <template v-else>
        <v-list-item-action>
          <v-icon v-if="data.item.icon">{{ data.item.icon }}</v-icon>
          <v-icon v-else>{{ data.item.route? 'mdi-launch' : 'mdi-folder'}}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{data.item.text}}
            <span v-if="data.item.desc" class="grey--text"> ({{data.item.desc}})</span>
          </v-list-item-title>
          <v-list-item-subtitle>{{data.item.subTitle}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="hasQuickLaunch">
          <v-btn icon ripple @click.stop="toggleQuickLaunch(data.item.name)">
            <v-icon color="primary">{{checkQuickLaunch(data.item.name) ? 'mdi-star' : 'mdi-star-outline'}}</v-icon>
          </v-btn>
        </v-list-item-action>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import clone from 'clone'
import { Menu } from '@/const/menu'
import { addAccess, flattenSearchableMenu } from '@/utils/menu'
import { mapGetters } from 'vuex'
import Routable from '@/mixins/routable'
import { APP_TOGGLE_SEARCH } from '@/store/types'
import app from '@/store/modules/app'

export default {
  data() {
    return {
      searchKey: null,
      searchLoading: false,
      searchResults: [],
      resolveValue: null,
      searchableInternalMenu: {}
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumb'
    ]),
    hasQuickLaunch() {
      if (this.$store.state.widgets.quickLaunch.init === 1) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    searchKey(val) {
      if (val) {
        this.querySearch(val)
      }
    },
    resolveValue(val) {
      this.searchSelect(val)
    }
  },
  methods: {
    querySearch(val) {
      // Search Search
      this.searchLoading = true

      // Search menu lists with key
      const tempSearchResult = this.searchInternalMenu(val)
      if (tempSearchResult && Object.keys(tempSearchResult).length !== 0) {
        let newSearchResults = []
        const keys = Object.keys(tempSearchResult)
        for (let i = 0; i < keys.length; i++) {
          // Add custom properties to search result (custom relationship pathing)
          let loopedResult = tempSearchResult[keys[i]]
          const breadcrumb = this.derieveBreadcrumb(keys[i])
          if (breadcrumb && breadcrumb.length > 0) {
            let subTitle = ''
            for (let x = 0; x < breadcrumb.length; x++) {
              if (x !== 0) {
                subTitle = subTitle + ' / '
              }
              subTitle = subTitle + breadcrumb[x].text
            }
            Object.assign(loopedResult, {
              subTitle: subTitle
            })
          } else {
            Object.assign(loopedResult, {
              subTitle: ''
            })
          }
          if (loopedResult.hidden) {
            continue
          }
          newSearchResults.push(loopedResult)
          if (newSearchResults.length === 5) {
            // Limit the search result processing to max 5
            break
          }
        }
        this.searchResults = newSearchResults
      } else {
        this.searchResults = []
      }
      // End Search
      this.searchLoading = false
    },
    searchInternalMenu(keyword) {
      const formattedKeyword = keyword ? keyword.toLowerCase() : null
      const searchableInternalMenu = app.state.internalMenu
      const result = Object.keys(searchableInternalMenu).reduce(function (r, e) {
        const formattedText = searchableInternalMenu[e].text ? searchableInternalMenu[e].text.toLowerCase() : null
        if (formattedKeyword !== null && formattedText !== null && formattedText.indexOf(formattedKeyword) !== -1) {
          r[e] = searchableInternalMenu[e]
        }
        return r
      }, {})
      return result
    },
    searchSelect(val) {
      if (val !== null) {
        // If it is launch from SearchBar, close it
        this.$store.commit(APP_TOGGLE_SEARCH, false)

        // find the list value
        const menuVal = this.searchResults.find(x => x.name === val)
        if (menuVal) {
          this.launchApp(menuVal.name, menuVal.route)
        }

        // reset data
        this.resolveValue = ''
        this.$nextTick(() => {
          this.resolveValue = null
        })
        this.searchResults = []
      }
    }
  },
  beforeMount() {
    // Port in Menu from const and add in access control
    const fullItems = clone(Menu)
    addAccess(fullItems[0].children)
    // removeEmptyChild(fullItems[0].children)
    this.searchableInternalMenu = flattenSearchableMenu(fullItems)
  },
  props: [
    'propclass'
  ],
  mixins: [
    Routable
  ]
}
</script>

<style lang="scss">
</style>
